import React from 'react'
import PropTypes from 'prop-types'
import Config from '../config'
import { formatCount, locationLabel, osmUrl } from './swimLocationStats'

const WEBAPP_POOL_URL = 'https://app.myswimpro.com/pools/'

// Published locations worth a look by hand, most swimmers first: the ones
// that most people will see without a name, or with a dubious one.
const LocationWorklistComponent = ({ rows, showName, emptyText }) => {
  if (rows.length === 0) {
    return <div className="text-muted">{emptyText}</div>
  }

  // The directory pages only exist on prod; a dev objectId would 404 there.
  const isProduction = Config.getEnvironment().toLowerCase() !== 'dev'

  return (
    <div className="table-responsive">
      <table className="table table-sm table-hover align-middle">
        <thead>
          <tr>
            {showName && <th>Name</th>}
            <th>Location</th>
            <th className="text-end">Swimmers</th>
            <th className="text-end">Swims</th>
            <th>Links</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(row => {
            const mapUrl = osmUrl(row)
            return (
              <tr key={row.id}>
                {showName && <td>{row.name}</td>}
                <td>{locationLabel(row)}</td>
                <td className="text-end">
                  {formatCount(row.uniqueUserCount)}
                </td>
                <td className="text-end">{formatCount(row.workoutCount)}</td>
                <td className="text-nowrap">
                  {mapUrl && (
                    <a href={mapUrl} target="_blank" rel="noreferrer">
                      Map
                    </a>
                  )}
                  {isProduction && (
                    <a
                      className="ms-3"
                      href={WEBAPP_POOL_URL + row.id}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Page
                    </a>
                  )}
                  <code className="ms-3 text-muted">{row.id}</code>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

LocationWorklistComponent.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    subtitle: PropTypes.string,
    cityName: PropTypes.string,
    countryCode: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    uniqueUserCount: PropTypes.number,
    workoutCount: PropTypes.number
  })).isRequired,
  showName: PropTypes.bool.isRequired,
  emptyText: PropTypes.string.isRequired
}

export default LocationWorklistComponent
